import { useEffect } from "react";
import { useFirstMountState } from "react-use";
import { Loading } from "@components/LoadMore/LoadMore";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { useMyBtKeywords } from "@features/mybt/hooks/useMyBtKeywords";
import { useGetMyBTArticleList } from "@routes/MyAccount/hooks/useGetMyBTArticleList";
import { GaObject } from "@routes/MyAccount/utils/types";

import MyAccountMyBTPageEmptyState from "./MyAccountMyBTPageEmptyState";
import MyAccountMyBTPageList from "./MyAccountMyBTPageList";

export default function MyAccountMyBtPage(): React.ReactElement {
  const sendDataToGTM = useGTMDispatch();
  const isFirstMount = useFirstMountState();

  const { tags } = useMyBtKeywords();

  const { myBTArticleList, isLoading, ref } = useGetMyBTArticleList({
    tags,
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isFirstMount) return;

    const userKeywords = tags.map(({ name }) => name).join("|");

    const gaObject: GaObject = {
      event: "custom_event",
      eventCategory: "mybt",
      eventAction: "visible",
      eventLabel: window.location.href,
    };

    if (userKeywords) {
      gaObject["user_keyword"] = userKeywords;
    }

    sendDataToGTM(gaObject);
  }, [tags, sendDataToGTM, isFirstMount]);

  return (
    <div data-testid="my-account-my-bt-page-component" className="w-full">
      {myBTArticleList.length > 0 ? (
        <MyAccountMyBTPageList
          tagWithArticleList={myBTArticleList}
          loadMoreRef={ref}
        />
      ) : (
        <MyAccountMyBTPageEmptyState />
      )}

      <Loading isLoading={isLoading} />
    </div>
  );
}
